import { ReactComponent as ShopifyWidget } from '../../../assets/shopify-widget.svg'
import { ReactComponent as ScreenWidget } from '../../../assets/screen-widget.svg'
import { ReactComponent as KithWidget } from '../../../assets/kith-widget.svg'
import { ReactComponent as PalaceWidget } from '../../../assets/palace-widget.svg'
import { ReactComponent as SupremeWidget } from '../../../assets/supreme-widget.svg'

const WidgetData = [
    {
        widgetIcon: ShopifyWidget,
        widgetText: 'Shopify Module',
    },
    {
        widgetIcon: SupremeWidget,
        widgetText: 'Supreme Module',
    },
    {
        widgetIcon: KithWidget,
        widgetText: 'Kith Module',
    },
    {
        widgetIcon: PalaceWidget,
        widgetText: 'Palace Module',
    },
    {
        widgetIcon: ScreenWidget,
        widgetText: 'Home Widgets',
    },
    // {
    //     widgetIcon: QueueWidget,
    //     widgetText: 'Queue Tool',
    // },
    // {
    //     widgetIcon: CalendarWidget,
    //     widgetText: 'Release Calendar',
    // },
]

export default WidgetData
